import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseAvatarSize, BaseButtonSize, CustomerBranchListItemResponse } from 'base';

@Component({
  selector: 'base-customer-provider-list-item',
  templateUrl: './base-customer-provider-list-item.component.html',
})
export class BaseCustomerProviderListItemComponent {
  @Input() provider: CustomerBranchListItemResponse | undefined;
  @Output() openIZSInfo = new EventEmitter<{
    event: Event;
    data: CustomerBranchListItemResponse;
  }>();

  buttonSize = BaseButtonSize;
  avatarSize = BaseAvatarSize;

  onIZSInfoOpen(event: Event): void {
    if (!this.provider) {
      return;
    }

    this.openIZSInfo.emit({ event, data: this.provider });
  }
}
